import { useCallback } from 'react';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import type { LegacyTrackNewsItemViewEventData } from './legacy-types';

export const createLegacyTrackNewsItemView = (
  id: string,
  name: string,
): LegacyTrackNewsItemViewEventData => {
  const eventData: LegacyTrackNewsItemViewEventData = {
    eventType: 'newsItemView',
    newsItemId: id,
    newsItemName: name,
  };

  return eventData;
};

export const useLegacyTrackNewsItemView = () => {
  const { track } = useLegacyTracking();

  const trackLegacyNewsItemView = useCallback(
    (id: string, name: string) => {
      track({
        event: 'newsItemView',
        data: createLegacyTrackNewsItemView(id, name),
      });
    },
    [track],
  );

  return {
    trackLegacyNewsItemView,
  };
};
